import styled from 'styled-components';

export const ContentWrapper = styled.div`
  margin-bottom: 1em;

  @media (min-width: 575px) {
    font-size: 15px;
  }
  @media (min-width: 992px) {
    font-size: 20px;
  }

  p {
    margin-top: 0;
  }

  ol, ul {
    padding: 0;
    list-style: decimal inside none;

    li {
      margin: 20px 0;
    }
  }
`;
